export default {
  catalogManagementUnits: [],
  catalogWorkPlans: [],
  apiCallsInProgress: 0,
};
